import script from "./OrderCategories.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderCategories.vue?vue&type=script&setup=true&lang=js"

import "./OrderCategories.vue?vue&type=style&index=0&id=5686b623&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5686b623"]])

export default __exports__